import { render, staticRenderFns } from "./SupplierColumn.vue?vue&type=template&id=f10f9b56&"
import script from "./SupplierColumn.vue?vue&type=script&lang=js&"
export * from "./SupplierColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports